<template>
  <div>
    <!-- 广告位 -->
    <ad-top></ad-top>
    <div class="tool-card-list">
      <el-row>
        <el-col :xs="24" :sm="12" :md="8" :xl="6">
          <ToolCard :title="$t('pageTitle.timeClac')" :intro="$t('tools.timeClac.introductionSimple')" tool="time_clac" :img="timeClacImg"></ToolCard>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :xl="6">
          <ToolCard class="tool-card" :title="$t('pageTitle.imgSplitter')" :intro="$t('tools.imgSplitter.introductionSimple')" tool="img_splitter" :img="imgSplitter" iconDesc="Icon made by Nikita Golubev, https://www.flaticon.com/authors/nikita-golubev"></ToolCard>
        </el-col>
        <!-- <el-col :xs="24" :sm="12" :md="8">
          <ToolCard class="tool-card" :title="$t('pageTitle.idPhotoEditor')" :intro="$t('tools.idPhotoEditor.introductionSimple')" tool="id_photo_editor" :img="timeClacImg"></ToolCard>
        </el-col> -->
        <el-col :xs="24" :sm="12" :md="8" :xl="6">
          <ToolCard class="tool-card" :title="$t('pageTitle.lifeRestart')" :intro="$t('tools.lifeRestart.introductionSimple')" tool="life_restart" :img="lifeRestart"></ToolCard>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :xl="6">
          <ToolCard class="tool-card" :title="$t('pageTitle.stopwatch')" :intro="$t('tools.stopwatch.introductionSimple')" tool="stopwatch" :img="stopwatch"></ToolCard>
        </el-col>
      </el-row>  
    </div>
    <!-- 广告位 -->
    <ad-bottom></ad-bottom>
  </div>
</template>

<script>
import ToolCard from '../components/tool-card'
import adTop from '../components/ad/ad-top'
import adBottom from '../components/ad/ad-bottom'

export default {
  name: 'index',
  components: { 
    ToolCard,
    adTop,
    adBottom
  },
  data() {
    return {
        timeClacImg: require('../assets/icons/time_calc.svg'),
        imgSplitter: require('../assets/icons/img_splitter.svg'),
        lifeRestart: require('../assets/icons/life_restart.png'),
        stopwatch: require('../assets/icons/stopwatch.png')
    }
  }
}
</script>
<style scoped>
.tool-card-list {
    padding-left: 130px; 
    padding-right: 130px;
}
@media screen and (max-width: 992px) {
  .tool-card-list {
    padding-left: 0; 
    padding-right: 0;
  }
  .tool-card {
    padding-top: 30px;
  }
}
@media screen and (max-width: 1920px) {
  .tool-card {
    padding-top: 30px;
  }
}
</style>